import { render, staticRenderFns } from "./DealReportDetail.vue?vue&type=template&id=5c3a0b0b&"
import script from "./DealReportDetail.vue?vue&type=script&lang=js&"
export * from "./DealReportDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports